import { FC } from 'react'

import { CustomTheme } from 'themes/types'

import { LinkProps, Link as MuiLink } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: CustomTheme) => ({
    link: {
        textDecoration: 'none',
        color: theme.color.link.active,
        fontWeight: 600,
    },
}))

const Link: FC<LinkProps> = ({ children, ...rest }) => {
    const classes = useStyles()

    return (
        <MuiLink className={classes.link} {...rest}>
            {children}
        </MuiLink>
    )
}

export default Link
